import { useSearchParams } from 'react-router';
import type { FeatureFlags } from '@modules/root';
import { hasFeature, useFeatureFlags } from '@modules/root';

/**
 * Single gate for the 2026 article detail revamp, shared by the reader-facing
 * article route and the page builder so the revamp render, its section
 * choices and its editor affordances toggle together. Rides the consolidated
 * `revamp_2026` CMS flag; in local dev only, `?revamp=1` forces it so the
 * pages can be QA'd before the flag exists on the team server.
 */
const isGateOn = (
    featureFlags: FeatureFlags,
    searchParams: URLSearchParams,
): boolean =>
    hasFeature(featureFlags, 'revamp_2026') ||
    (process.env.NODE_ENV !== 'production' &&
        searchParams.get('revamp') === '1');

export const isArticleRevampEnabled = (
    featureFlags: FeatureFlags,
    url: URL,
): boolean => isGateOn(featureFlags, url.searchParams);

/** The same gate for components, from app data and the current location. */
export const useArticleRevampEnabled = (): boolean => {
    const featureFlags = useFeatureFlags();
    const [searchParams] = useSearchParams();
    return isGateOn(featureFlags, searchParams);
};
